<template>
    <div class="user">
        <div class="condition">
            <div class="item">
                <div class="label">手机号:</div>
                <el-input v-model="conditionData.phone" size="small" placeholder="请输入"></el-input>
            </div>
            <div class="item">
                <div class="label">微信:</div>
                <el-input v-model="conditionData.weChat" size="small" placeholder="请输入"></el-input>
            </div>
            <div class="item">
                <div class="label">昵称:</div>
                <el-input v-model="conditionData.nickName" size="small" placeholder="请输入"></el-input>
            </div>
            <div class="item">
                <div class="label">城市:</div>
                <el-input v-model="conditionData.City" size="small" placeholder="请输入"></el-input>
            </div>
            <div class="item">
                <div class="label">账号状态:</div>
                <el-select v-model="conditionData.enable" size="small" placeholder="请选择">
                    <el-option
                    v-for="item in enableList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="item">
                <div class="label">性别:</div>
                <el-select v-model="conditionData.Gender" size="small" placeholder="请选择">
                    <el-option
                    v-for="item in genderList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <!-- <div class="item">
                <div class="label">是否是vip:</div>
                <el-select v-model="conditionData.Vip" size="small" placeholder="请选择">
                    <el-option
                    v-for="item in vipList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="item">
                <div class="label">是否已处理:</div>
                <el-select v-model="conditionData.IsChuli" size="small" placeholder="请选择">
                    <el-option
                    v-for="item in IsJUserList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div> -->
            <div class="btns">
                <el-button type="primary" size="small" @click="selectData()">查询</el-button>
                <el-button type="warning" size="small" @click="reset()">重置</el-button>
            </div>
        </div>

        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <div>
                    <!-- <el-button type="primary" icon="el-icon-circle-plus" size="small" @click="addDialogShow()">新建</el-button> -->
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                style="width: 100%"
                height="600px">
                
                <el-table-column
                type="index"
                width="60"
                label="序号"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="phone"
                label="账号"
                align="center"
                >
                
                </el-table-column>
                
                <!-- <el-table-column
                prop="isJUser"
                label="是否真实用户"
                align="center"
                width="110px"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.isJUser">真实用户</span>
                        <span v-else>否</span>
                    </template>
                </el-table-column> -->
                <el-table-column
                prop="nickName"
                label="用户昵称"
                align="center"
                >
                <template slot-scope="scope">
                    <span>{{ scope.row.nickName }}</span>
                    <span v-if="scope.row.isJUser">(*)</span>
                    <span v-else></span>
                </template>
                </el-table-column>
                
                <!-- <el-table-column
                prop="age"
                label="年龄"
                align="center"
                width="70"
                >
                </el-table-column> -->
                
                <el-table-column
                prop="gender"
                label="性别"
                align="center"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.gender==1">男</span>
                        <span v-else>女</span>
                    </template>
                </el-table-column>

                <!-- <el-table-column
                prop="shenhe"
                label="审核状态"
                align="center"
                width="140"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.shenhe==-1">审核失败</span>
                        <span v-else-if="scope.row.shenhe==1">审核中</span>
                        <span v-else>审核通过</span>
                    </template>
                </el-table-column> -->
                <el-table-column
                prop="weChat"
                label="微信"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="state"
                label="状态"
                align="center"
                >
                <template slot-scope="scope">
                    {{scope.row.state == 1?'正常':''}}
                    {{scope.row.state == -1?'冻结':''}}
                    {{scope.row.state == -2?'注销':''}}
                    <!-- <el-button type="text" icon="el-icon-edit" size="mini" @click="updateTip(scope.row)">处理用户</el-button> -->
                </template>
                </el-table-column>
                <el-table-column
                prop="userInfoVo.weChatReview"
                label="原因"
                align="center"
                width="250px"
                >
                <template slot-scope="scope">
                    {{scope.row.userInfoVo.weChatReview}}
                </template>
                </el-table-column>
                <el-table-column
                prop="reviewWeChatTime"
                label="修改时间"
                align="center"
                >
                
                </el-table-column>
                <el-table-column
                fixed="right"
                label="操作"
                width="220px"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-edit" size="mini" @click="updateTip(scope.row)">处理用户</el-button>
                </template>
                </el-table-column>
            </el-table>

            <div class="page">
                <el-pagination
                @current-change="handleCurrentChange"
                    background
                    layout="sizes,prev, pager, next"
                    :total="totalCount"
                    :current-page="conditionData.current"
                    :page-size="conditionData.size"
                    :page-sizes="[10,50,100 ]"
                    @size-change="handleSizeChange">
                </el-pagination>
                
            </div>
        </div>
      

        <el-dialog :close-on-click-modal="false" :visible.sync="isDetailDialog" title="用户详情" width="720px">
            <div class="dialog">
                <div class="picList">
                    <div class="pic" v-for="(item,index) in piclist" :key="index">
                        <el-image
                        style="width: 100px; height: 100px"
                        :src="item.picPath"
                        :preview-src-list="[item.picPath]"
                        fit="cover"></el-image>
                        <img src="../../../assets/images/icon08.png" class="pic-edit" alt="" @click="delPicTip(item)">
                    </div>
                </div>
                <div class="btns" style="margin-top:20px">
                    <el-button type="primary" icon="el-icon-edit" @click="isDetailDialog = false">确认</el-button>
                </div>
                
                
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="isSetUnlockNumber" title="设置交换次数" width="720px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        增加交换次数
                    </div>
                    <div class="value">
                        <el-input v-model="setUnlockNumberData.unlockNumber" size="small" placeholder="请输入" type="number"></el-input>
                    </div>
                    <el-button type="primary" icon="el-icon-edit" size="small" @click="setUnlockNumberApi()">确认</el-button>
                </div>

            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="isVip" title="设置会员" width="720px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        是否会员
                    </div>
                    <div class="value">
                        <el-select v-model="vipData.vip" size="small" placeholder="请选择">
                            <el-option
                            v-for="item in vipList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        会员结束时间
                    </div>
                    <div class="value">
                        <el-date-picker
                        v-model="vipData.endTime"
                        type="date"
                        format="yyyy-MM-dd"
                        size="small"
                        placeholder="选择日期">
                        </el-date-picker>
                    </div>
                </div>
                <div class="btns" style="margin-top:20px">
                    <el-button type="primary" icon="el-icon-edit" @click="setVip()">确认</el-button>
                </div>

            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="isJinBiDialog" title="设置金币" width="720px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        金币
                    </div>
                    <div class="value">
                        <el-input v-model="JinBiData.jinBi" placeholder="请输入金币数量" type="number"></el-input>
                    </div>
                </div>
                
                <div class="btns" style="margin-top:20px">
                    <el-button type="primary" icon="el-icon-edit" @click="setJinBi()">确认</el-button>
                </div>

            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="isDynamicNumberDialog" title="设置交换次数" width="720px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        增加发布动态次数
                    </div>
                    <div class="value">
                        <el-input v-model="dynamicNumberData.dynamicNumber" size="small" placeholder="请输入" type="number"></el-input>
                    </div>
                    <el-button type="primary" icon="el-icon-edit" size="small" @click="setDynamicNumberData()">确认</el-button>
                </div>

            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="isFrozenDialog" :title="'冻结用户-'+username" width="720px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        冻结原因
                    </div>
                    <div class="valuet">
                        <el-input v-model="frozenData.reason" size="small" placeholder="请输入" type="textarea" :rows="4"></el-input>
                    </div>
                </div>
                <div class="btns" style="margin-top:20px">
                    <el-button type="primary" icon="el-icon-edit" @click="dongjie()">确认</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="isThawDialog" :title="'解冻用户-'+username" width="720px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        解冻原因
                    </div>
                    <div class="valuet">
                        <el-input v-model="thawData.reason" size="small" placeholder="请输入" type="textarea" :rows="4"></el-input>
                    </div>
                </div>
                <div class="btns" style="margin-top:20px">
                    <el-button type="primary" icon="el-icon-edit" @click="jiedong()">确认</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="isEditDialog" :title="'编辑用户-'+username" width="720px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        用户昵称
                    </div>
                    <div class="valuet">
                        <el-input v-model="editData.nickName" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        微信号
                    </div>
                    <div class="valuet">
                        <el-input v-model="editData.weChat" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="btns" style="margin-top:20px">
                    <el-button type="primary" icon="el-icon-edit" @click="editDataFun()">确认</el-button>
                </div>
            </div>
        </el-dialog>

        <!-- 大图预览 -->
        <el-image-viewer
            v-if="showBigImg"
            :on-close="closeViewer"
            :url-list="showBigImgList"
            :initial-index="imgIndex"
        />
        
    </div>
</template>
<script>
import api from '../../../api/main'
import {parseTimeS} from '../../../utils/index'
import {genderList,vipList,shenHeList,enableList} from '../../../assets/selectList/anxin'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
export default {
    name: 'user',
    data () {
        return {
            userId:'',
            vipList:vipList,
            enableList:enableList,
            genderList:genderList,
            shenHeList:shenHeList,
            isShow:false,
            totalCount:0,
            isDetailDialog:false,
            detailData:{},
            piclist:[],
            conditionData:{
                weChat:'',
                nickName:'',
                IsChuli:false,
                current:1,
                size:10,
            },
            tableData:[],
           

            showBigImg:false,
            showBigImgList:[],
            imgIndex:0,
            userId:'',
            // 交换次数
            isSetUnlockNumber:false,
            setUnlockNumberData:{},
            // 会员设置
            isVip:false,
            vipData:{},
            // 动态次数
            isDynamicNumberDialog:false,
            dynamicNumberData:{},

            frozenData:{
                "userId": null,
                "reason": ""
            },
            isFrozenDialog:false,
            username:'',
            thawData:{
                "userId": null,
                "reason": ""
            },
            isThawDialog:false,

            isJinBiDialog:false,
            JinBiData:{
                "userId": null,
                "jinBi": 0
            },
            isEditDialog:false,
            editData:{
                "id": 0,
                "userId": 0,
                "nickName": "",
                "age": 0,
                "gender": 1,
                "city": "",
                "birthday": "",
                "shenGao": "",
                "tiZhong": "",
                "zhiYe": "",
                "love": "",
                "header": "",
                "lng": 0,
                "lat": 0,
                "address": "",
                "weChat": "",
                "unlockNumber": 0
            },
            IsJUserList:[{
                label:'是',
                value:true,
            },{
                label:'否',
                value:false,
            }]
        }
    },
    components:{
        ElImageViewer
    },
    created(){

    },
    mounted(){
        setTimeout(() => {
            this.loadingData();
        }, 300)
    },
    methods:{
        
        delPicTip(row){
            this.$confirm('将删除此照片?', '是否继续', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.delPic(row);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        
        async delPic(row){
            let res = await api.deleteUserInfoPicById(row.id);
            if(res.data.code == '200'){
                this.isEditDialog = false;
                this.$message({
                    type: 'success',
                    message: '删除成功'
                });   
                this.isDetailDialogShow({userId:this.userId});
            }
        },
        deleteTip(row){
            this.$confirm('将删除用户?', '是否继续', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteItem(row);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        updateTip(row){
            this.$confirm('审核用户——'+row.nickName+',是否通过', '是否继续', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let data = {
                    userId:row.userId,
                    reviewWeChatState:1,
                    state:1,
                }
                this.updateApi(data);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        async updateApi(item){
            item.state = 1;
            let res = await api.AdminStandUpdateShenHe(item);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '编辑成功'
                });   
                this.loadingData();
            }
        },
        async editDataFun(){
            let res = await api.AdminStandUpdateUserInfo(this.editData);
            console.log(res);
            if(res.data.code == '200'){
                this.isEditDialog = false;
                this.$message({
                    type: 'success',
                    message: '编辑成功'
                });   
                this.loadingData();
            }
        },
        async deleteItem(row){
            let res = await api.deleteUser(row.userId);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '删除成功'
                });   
                this.loadingData();
            }
        },
        // 动态次数
        dynamicNumberDialog(row){
            console.log(row);
            this.isDynamicNumberDialog = true;
            this.dynamicNumberData = {
                "userId": row.userId,
                "dynamicNumber": 0,
            };
        },
        async setDynamicNumberData(){
            this.isDynamicNumberDialog = false;
            this.dynamicNumberData.dynamicNumber = parseFloat(this.dynamicNumberData.dynamicNumber)
            let res = await api.setDynamicNumber(this.dynamicNumberData);
            if(res.data.code == "200"){
                this.$message({
                    type: 'success',
                    message: '设置成功!'
                });
                this.loadingData();
            }
        },
        // 设置vip
        vip(row){
            console.log(row);
            this.isVip = true;
            this.vipData = {
                "userId": row.userId,
                "vip": row.vip,
                "endTime":row.vipEndDate
            };
        },
        async setVip(){
            this.isVip = false;
            let res = await api.AdminStandSetVip(this.vipData);
            if(res.data.code == "200"){
                this.$message({
                    type: 'success',
                    message: '设置成功!'
                });
                this.loadingData();
            }
        },

        setJinBiTip(row){
            this.isJinBiDialog = true;
            this.JinBiData = {
                "userId": row.userId,
                "jinBi": '',
            };
        },
        async setJinBi(){
            this.JinBiData.jinBi = parseFloat(this.JinBiData.jinBi?this.JinBiData.jinBi:0);
            let res = await api.AdminStandSetJinbi(this.JinBiData);
            if(res.data.code == "200"){
                this.isJinBiDialog = false;
                this.$message({
                    type: 'success',
                    message: '设置金币成功!'
                });
                this.loadingData();
            }
        },
        // 交换次数
        setUnlockNumber(row){
            this.isSetUnlockNumber = true;
            this.setUnlockNumberData = {
                "userId": row.userId,
                "unlockNumber": 0,
            };
        },
        async setUnlockNumberApi(){
            this.isSetUnlockNumber = false;
            this.setUnlockNumberData.unlockNumber = parseFloat(this.setUnlockNumberData.unlockNumber)
            let res = await api.AdminStandSetUnlockNumber(this.setUnlockNumberData);
            if(res.data.code == "200"){
                this.$message({
                    type: 'success',
                    message: '设置成功!'
                });
                this.loadingData();
            }
        },
        // 冻结提示
        dongjieTip(item){
            console.log(item);
            this.username = item.nickName
            this.frozenData.userId = item.userId;
            this.isFrozenDialog =true;
        },
        async dongjie(){
            let res = await api.AdminStandFrozen(this.frozenData);
            if(res.data.code == "200"){
                this.$message({
                    type: 'success',
                    message: '冻结成功!'
                });
                this.isFrozenDialog =false;
                this.loadingData();
            }
        },

        // 解冻提示
        jiedongTip(item){
            console.log(item);
            this.username = item.nickName
            this.thawData.userId = item.userId;
            this.isThawDialog =true;
        },
        async jiedong(){
            let res = await api.AdminStandThaw(this.thawData);
            if(res.data.code == "200"){
                this.$message({
                    type: 'success',
                    message: '解冻成功!'
                });
                this.isThawDialog =false;
                this.loadingData();
            }
        },
        auditUser(row){
        },
        // 审核图片
        async auditPic(item){
            console.log(item);
            this.$confirm('将审核通过?', '是否继续', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.auditPicApi(item);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
            return
        },
        async auditPicApi(item){
            let res = await api.shenHeUserInfoPic({
                userId:item.userId,
                userInfoPicId:item.id,
                shenHe:2,
            });
            if(res.data.code == "200"){
                this.$message({
                    type: 'success',
                    message: '审核成功!'
                });
                this.isDetailDialogShow({userId:this.userId});
            }
        },
        // 图片查看
        closeViewer(){
            this.showBigImg = false;
        },
        showHeader(url){
            this.showBigImgList = [url];
            this.showBigImg = true;

        },
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        async loadingData() {
            let res  = await api.AdminStandQueryShenHe(this.conditionData);
            this.tableData = res.data.data.records;
            this.totalCount = res.data.data.total;
            for(let index in this.tableData){
                this.tableData[index].Time = parseTimeS(this.tableData[index].Time);
            }
        },
        selectData(){
            this.conditionData.current = 1;
            this.loadingData();
        },
      
        
        
        handleCurrentChange(page){
            this.conditionData.current = page;
            this.loadingData();
        },
        handleSizeChange(size){
            this.conditionData.current = 1;
            this.conditionData.size = size;
            this.loadingData();
        },
        async isDetailDialogShow(row){
            this.isDetailDialog = true;
            // this.detailData = row;
            let res = await api.QueryUserInfoPicByUserId(row.userId);
            console.log(res);
            this.piclist = res.data.data;
            this.userId = row.userId;
            // this.isDetailDialogShow();
        },
       
        // 重置
        reset(){
            this.conditionData = {
                weChat:'',
                nickName:'',
                current: 1,
                size: 10,
            },
            this.loadingData();
        },
        
        
        
       
    }
    
}
</script>

<style lang="scss" scoped>
    .condition{
        background-color: #ffffff;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        border-radius: 5px;
        padding: 10px;
        font-size: 14px;
        .item{
            display: flex;
            align-items: center;
            margin-right: 20px;
            padding: 5px;
            .label{
                min-width: 110px;
            }
        }
        .btns{
        }
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        
        ::v-deep .table-expand {
            font-size: 0;
        }
        .row{
            display: flex;
        }
        ::v-deep .table-expand label {
            width: 150px;
            padding-left: 50px;
            color: #99a9bf;
        }
        ::v-deep .table-expand span {
            color: #222222;
        }
        ::v-deep .table-expand .btn span{
            color: #409eff;
        }
        ::v-deep .table-expand .el-form-item {
            margin-right: 0;
            margin-bottom: 0;
            width: 450px;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }
    .dialog{
        display: flex;
        flex-direction: column;
        padding-top: 16px;
        height: 100%;
        // overflow: scroll;
        .item{
            font-size: 14px;
            padding:8px 15px;
            display: flex;
            align-items: center;
            .label{
                width: 120px;
                margin-bottom: 5px;
            }
            .input{
                width: 215px;
                display: flex;
            }
            .valuet{
                width: 450px;
            }
        }
        .picList{
            display: flex;
            flex-wrap: wrap;
            .pic{
                position: relative;
                margin: 5px;
                width: 100px;
                height: 100px;
                .pic-edit{
                    position: absolute;
                    z-index: 10;
                    top: 0;
                    right: 0;
                    width: 20px;
                    height: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background-color: rgba(0, 0, 0 , 0.6);
                    cursor: pointer;
                    i{
                        color: #ffffff;
                    }
                    .error{
                        color: #f56c6c;
                    }
                    .success{
                        color: #a9ffa9;
                    }
                }
            }
        }
        .btns{
            background-color: #ffffff;
            width: 100%;
            bottom: 0;
            display:flex;
            flex-direction: row-reverse;
            .el-button{
                margin-right: 10px;
            }
        }
    }
</style>
